import * as React from "react";

import { OhCase, sortOhCaseTimeline } from "../../model";

import { TaskTimelineRow } from "./TaskTimelineRow";
import { AppointmentTimelineRow } from "./AppointmentTimelineRow";

interface Props {
    ohCase: OhCase;
}

export const OhCaseTimeline: React.FunctionComponent<Props> = (props: Props) => {
    const appointmentIds = (props.ohCase.appointments || []).map(a => a.id);
    const appointments = (props.ohCase.appointments || []).map(a => ({
        completed: a.end.isBefore(),
        completedDate: a.end,
        dateCreated: a.start,
        render: <AppointmentTimelineRow appointment={a} key={a.id} />
    }));
    const tasks = (props.ohCase.tasks || [])
        .filter(t => appointmentIds.some(id => id === t.appointmentId) !== true)
        .map(t => ({
            ...t,
            render: <TaskTimelineRow task={t} key={t.id} />
        }));
    const events = <>{sortOhCaseTimeline([...appointments, ...tasks]).map(x => x.render)}</>;
    return events;
};
